import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  viewChild,
} from '@angular/core';
import { Option } from '../../../core/models/model';
import { SelectComponent } from '../select/select.component';

@Component({
  selector: 'sc-option',
  imports: [],
  templateUrl: './option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionComponent {
  constructor(
    private selectComponent: SelectComponent,
    public cdr: ChangeDetectorRef
  ) {}

  @Input()
  isActive: boolean;

  @Input()
  isSelected: boolean;

  @Input()
  option: Option;

  optionRef = viewChild<ElementRef>('optionRef');

  select() {
    if (!this.isSelected) {
      this.selectComponent.selectOptionComponent(this);
    }
  }

  focus() {
    if (this.optionRef) {
      this.optionRef().nativeElement.focus();
    }
  }

  ngAfterViewInit() {
    this.selectComponent.addOptionComponent(this);
    this.cdr.detectChanges();
  }
}
